import { render, staticRenderFns } from "./ManuscriptAutocomplete.vue?vue&type=template&id=52647068&"
import script from "./ManuscriptAutocomplete.vue?vue&type=script&lang=js&"
export * from "./ManuscriptAutocomplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports